/* eslint-disable react/jsx-props-no-spreading */
import './ExternalLink.scss';

import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

const ExternalLink = ({
  children,
  className,
  context,
  href,
  id,
  onClick,
  rel,
  target,
}) => {
  const classNames = useMemo(
    () => ['external-link', className].filter((item) => item).join(' '),
    [className],
  );

  const conditionalProps = useMemo(
    () => ({
      ...(id ? { id } : {}),
      ...(context ? { 'data-qa-id': context } : {}),
    }),
    [context, id],
  );

  return (
    <a
      className={classNames}
      {...conditionalProps}
      href={href}
      onClick={onClick}
      target={target}
      rel={rel}
    >
      {children}
    </a>
  );
};

ExternalLink.defaultProps = {
  children: null,
  className: null,
  context: null,
  href: null,
  id: '',
  onClick: () => {},
  rel: 'noopener noreferrer',
  target: '_blank',
};

ExternalLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  context: PropTypes.string,
  href: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  rel: PropTypes.string, // to specify with list of possible values
  target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top']), // frame name not added
};

export default ExternalLink;
